module.exports = __webpack_public_path__ + "img/filter.a3bf4de2.svg";